import { useRef, useState, useCallback, useEffect } from "react";
import { motion, useSpring } from "framer-motion";

/**
 * Wraps children in a magnetic hover effect that subtly follows the cursor.
 * @param {number} strength - Maximum offset in px (default 6)
 */
export default function MagneticButton({ children, strength = 6, className = "" }) {
  const ref = useRef(null);
  const [canHover, setCanHover] = useState(false);
  const x = useSpring(0, { stiffness: 300, damping: 20 });
  const y = useSpring(0, { stiffness: 300, damping: 20 });

  useEffect(() => {
    setCanHover(window.matchMedia("(hover: hover)").matches);
  }, []);

  const handleMouseMove = useCallback(
    (e) => {
      if (!canHover || !ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      x.set(((e.clientX - cx) / (rect.width / 2)) * strength);
      y.set(((e.clientY - cy) / (rect.height / 2)) * strength);
    },
    [canHover, strength, x, y]
  );

  const handleMouseLeave = useCallback(() => {
    x.set(0);
    y.set(0);
  }, [x, y]);

  return (
    <motion.div
      ref={ref}
      className={`inline-block ${className}`}
      style={{ x, y }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </motion.div>
  );
}
